import React, { useState, useEffect } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { useParams } from "react-router";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap";
import Menu from "./Menu";
let debounceTimer;
function BlogDetailsHero(data) {
  let listData = data.data;
  // const { id } = useParams();
  // const [listData, setListData] = useState({});
  // useEffect(() => {
  //   fetch("./assets/data/blogs.json", {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //   })
  //     .then(function (response) {
  //       return response.json();
  //     })
  //     .then(function (myJson) {
  //       const getDetails = myJson.filter((val) => val.id == id);
  //       setListData(getDetails[0]);
  //     });
  // }, []);
  let logoFawesome = "./assets/images/logo-fawesome-tv.svg";
  let searchIcon = "./assets/images/search.svg";
  const [inputValue, setInputValue] = useState("");
  let blogImage = listData?.image;
  if (listData?.image_banner) {
    blogImage = listData?.image_banner;
  }

  useEffect(() => {
    const navLinks = document.querySelectorAll(".bg-body-tertiary .nav-link");
    const searchInput = document.querySelectorAll(
      ".bg-body-tertiary #search-input"
    );
    navLinks.forEach((link) => {
      link.classList.add("gtm-lp", "gtm-nav-link");
    });
    searchInput.forEach((link) => {
      link.classList.add("gtm-lp", "gtm-search-text");
    });
  }, []);

  return (
    <>
      <Menu></Menu>
      <div className="row col-md-12 col-sm-12">
        <div className="col-md-6 col-sm-12 de-mob-image">
          <img
            src={blogImage}
            className="heropic-de"
            alt={listData?.alt_text}
          />
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="fCorLeftDe"></div>

          <div className="herotitleContDe">
            <p className="cta-intro-de">{listData?.date}</p>
            <div className="d-flex justify-content-start flex-wrap">
              <p>
                <img
                  style={{ width: "1em", marginBottom: "1em" }}
                  src="./assets/images/ico-timer.svg"
                ></img>
              </p>
              &nbsp;
              <div
                style={{ marginRight: "2em" }}
                className="bl-reading-time"
                dangerouslySetInnerHTML={{ __html: listData.reading_time }}
              />
              {/* <p>
                <a href={listData.author.url} target="_blank">
                  <img
                    style={{ width: "1em", marginBottom: "1em" }}
                    src="./assets/images/ico-linkedin.svg"
                  ></img>
                </a>
              </p>
              &nbsp; */}
              {/* <div className="bl-author" /> */}
              {/* <p className="blog-author">
                by:&nbsp;
                <a
                  href={listData.author.url}
                  target="_blank"
                  className="author-link"
                >
                  {listData.author.name}
                </a>
              </p> */}
            </div>

            <h1 className="herotitle-de">{listData?.title}</h1>
          </div>
        </div>

        <div className="col-md-6 col-sm-12 de-image">
          <img
            src={blogImage}
            className="heropic-de"
            alt={listData?.alt_text}
          />
        </div>
      </div>
    </>
  );

  function handleClick() {
    let urlFull = window.location.href;
    let url = urlFull;
    let qs = "";
    if (urlFull.indexOf("?") > -1) {
      url = urlFull.split("?")[0];
      qs = "?" + urlFull.split("?")[1];
    }
    var newUrl = url.replace(/\/#\/?$/, "");
    newUrl = window.location.protocol + "//" + window.location.hostname;
    var homePath = "/home/";
    if (newUrl.endsWith("/")) {
      homePath = "home/";
    }
    window.location.href = newUrl + homePath + qs;
  }

  function isValidInputForSearch(str) {
    // Regex allows input starting with letters or numbers, followed by any characters except %/\?
    return /^[a-zA-Z0-9](?!.*[%\/\\?]).*$/.test(str);
  }

  function handleChange(event) {
    var currentValue = event.target.value;
    if (!isValidInputForSearch(currentValue)) {
      event.target.value = currentValue.slice(0, -1); // Remove the last character if invalid
    }
    var searchText = event.target.value;
    setInputValue(searchText);
    // Set debounce delay in milliseconds
    var debounceDelay = 2000;
    // Check if searchText has at least 2 letters
    if (searchText.length >= 2) {
      // Clear previous debounce timer
      clearTimeout(debounceTimer);
      // Set new debounce timer
      debounceTimer = setTimeout(function () {
        window.location.href = `${document.location.origin}/search/${searchText}`;
      }, debounceDelay);
    }
  }

  function handleKeyDown(event) {
    var searchText = event.target.value;
    clearTimeout(debounceTimer);
    if (event.key === "Enter") {
      if (searchText.length >= 2) {
        window.location.href = `${document.location.origin}/search/${searchText}`;
      }
    }
  }
}
export default BlogDetailsHero;
